export const AUDIO_VISUAL = 'Audio visual';
export const BACKGROUND_MUSIC = 'Background music';
export const CDS_LPS_AP1 = 'CDs/LPs - AP1';
export const CDS_LPS_AP2_AP3 = 'CDs/LPs - AP2/AP3';
export const CINEMA = 'Cinema';
export const COVERMOUNTS = 'Covermounts';
export const LIVE = 'Live (except concerts)';
export const MUSIC_CHANNELS = 'Music channels';
export const ONLINE = 'Online';
export const RADIO = 'Radio';
export const RECORD_LABELS = 'Record labels';
export const TELEVISION = 'Television';

export const JAN = 'JAN';
export const FEB = 'FEB';
export const MAR = 'MAR';
export const APR = 'APR';
export const MAY = 'MAY';
export const JUN = 'JUN';
export const JUL = 'JUL';
export const AUG = 'AUG';
export const SEP = 'SEP';
export const OCT = 'OCT';
export const NOV = 'NOV';
export const DEC = 'DEC';

export const MONTHS = [
  { label: JAN, value: 'January' },
  { label: FEB, value: 'February' },
  { label: MAR, value: 'March' },
  { label: APR, value: 'April' },
  { label: MAY, value: 'May' },
  { label: JUN, value: 'June' },
  { label: JUL, value: 'July' },
  { label: AUG, value: 'August' },
  { label: SEP, value: 'September' },
  { label: OCT, value: 'October' },
  { label: NOV, value: 'November' },
  { label: DEC, value: 'December' },
];

export const PLACES = [
  { label: AUDIO_VISUAL, value: AUDIO_VISUAL },
  { label: BACKGROUND_MUSIC, value: BACKGROUND_MUSIC },
  { label: CDS_LPS_AP1, value: CDS_LPS_AP1 },
  { label: CDS_LPS_AP2_AP3, value: CDS_LPS_AP2_AP3 },
  { label: CINEMA, value: CINEMA },
  { label: COVERMOUNTS, value: COVERMOUNTS },
  { label: LIVE, value: LIVE },
  { label: MUSIC_CHANNELS, value: MUSIC_CHANNELS },
  { label: ONLINE, value: ONLINE },
  { label: RADIO, value: RADIO },
  { label: RECORD_LABELS, value: RECORD_LABELS },
  { label: TELEVISION, value: TELEVISION },
];

export const DATA = {
  [AUDIO_VISUAL]: {
    [JAN]: 'May',
    [FEB]: 'May',
    [MAR]: 'May',
    [APR]: 'August',
    [MAY]: 'August',
    [JUN]: 'August',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'February',
    [NOV]: 'February',
    [DEC]: 'February',
    type: 'Mechanical royalties',
  },
  [BACKGROUND_MUSIC]: {
    [JAN]: 'July',
    [FEB]: 'July',
    [MAR]: 'July',
    [APR]: 'October',
    [MAY]: 'October',
    [JUN]: 'October',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'April',
    [NOV]: 'April',
    [DEC]: 'April',
    type: 'Performing royalties',
  },
  [CDS_LPS_AP1]: {
    [JAN]: 'May',
    [FEB]: 'May',
    [MAR]: 'May',
    [APR]: 'August',
    [MAY]: 'August',
    [JUN]: 'August',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'February',
    [NOV]: 'February',
    [DEC]: 'February',
    type: 'Mechanical royalties',
  },
  [CDS_LPS_AP2_AP3]: {
    [JAN]: 'May',
    [FEB]: 'June',
    [MAR]: 'July',
    [APR]: 'August',
    [MAY]: 'September',
    [JUN]: 'October',
    [JUL]: 'November',
    [AUG]: 'December',
    [SEP]: 'January',
    [OCT]: 'February',
    [NOV]: 'March',
    [DEC]: 'April',
    type: 'Mechanical royalties',
  },
  [CINEMA]: {
    [JAN]: 'July',
    [FEB]: 'July',
    [MAR]: 'July',
    [APR]: 'October',
    [MAY]: 'October',
    [JUN]: 'October',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'April',
    [NOV]: 'April',
    [DEC]: 'April',
    type: 'Performing royalties',
  },
  [COVERMOUNTS]: {
    [JAN]: 'May',
    [FEB]: 'June',
    [MAR]: 'July',
    [APR]: 'August',
    [MAY]: 'September',
    [JUN]: 'October',
    [JUL]: 'November',
    [AUG]: 'December',
    [SEP]: 'January',
    [OCT]: 'February',
    [NOV]: 'March',
    [DEC]: 'April',
    type: 'Mechanical royalties',
  },
  [LIVE]: {
    [JAN]: 'July',
    [FEB]: 'July',
    [MAR]: 'July',
    [APR]: 'October',
    [MAY]: 'October',
    [JUN]: 'October',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'April',
    [NOV]: 'April',
    [DEC]: 'April',
    type: 'Performing royalties',
  },
  [MUSIC_CHANNELS]: {
    [JAN]: 'July',
    [FEB]: 'July',
    [MAR]: 'July',
    [APR]: 'October',
    [MAY]: 'October',
    [JUN]: 'October',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'April',
    [NOV]: 'April',
    [DEC]: 'April',
    type: 'Performing royalties',
  },
  [ONLINE]: {
    [JAN]: 'October',
    [FEB]: 'October',
    [MAR]: 'October',
    [APR]: 'December',
    [MAY]: 'December',
    [JUN]: 'December',
    [JUL]: 'April',
    [AUG]: 'April',
    [SEP]: 'April',
    [OCT]: 'July',
    [NOV]: 'July',
    [DEC]: 'July',
    type: 'Mechanical and Performing royalties',
  },
  [RADIO]: {
    [JAN]: 'July',
    [FEB]: 'July',
    [MAR]: 'July',
    [APR]: 'October',
    [MAY]: 'October',
    [JUN]: 'October',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'April',
    [NOV]: 'April',
    [DEC]: 'April',
    type: 'Mechanical and Performing royalties',
  },
  [RECORD_LABELS]: {
    [JAN]: 'May',
    [FEB]: 'May',
    [MAR]: 'May',
    [APR]: 'August',
    [MAY]: 'August',
    [JUN]: 'August',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'December',
    [OCT]: 'February',
    [NOV]: 'February',
    [DEC]: 'February',
    type: 'Mechanical royalties',
  },
  [TELEVISION]: {
    [JAN]: 'July',
    [FEB]: 'July',
    [MAR]: 'July',
    [APR]: 'October',
    [MAY]: 'October',
    [JUN]: 'October',
    [JUL]: 'December',
    [AUG]: 'December',
    [SEP]: 'April',
    [OCT]: 'April',
    [NOV]: 'April',
    [DEC]: 'April',
    type: 'Mechanical and Performing royalties',
  },
};
